import { SEARCH_SURVEYS_ENDPOINT } from '../../../../common/config/api_endpoints';
import {
  createAPILifecycleActions,
  createAPILifecycleActionTypes,
} from '../../../../redux/actions/action_utils';
import createAmplifyAPICallEpic from '../../../../redux/epics/utils';
import { extractTableDataFromPayload } from '../../../../common/components/table/utils/table_redux_payload_utils';

const CHECK_SURVEYS_ACTION_TYPES = createAPILifecycleActionTypes('CHECK_SURVEYS_ACTION_TYPES');
export const checkSurveysAction = createAPILifecycleActions(CHECK_SURVEYS_ACTION_TYPES.NAME);

const initialState = {
  isFetching: false,
  data: null,
  error: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CHECK_SURVEYS_ACTION_TYPES.BEGIN:
      return {
        ...state,
        isFetching: true,
      };
    case CHECK_SURVEYS_ACTION_TYPES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: {
          ...state.data,
          ...extractTableDataFromPayload(payload),
        },
        error: null,
      };
    case CHECK_SURVEYS_ACTION_TYPES.FAILURE:
      return {
        ...state,
        isFetching: false,
        data: null,
        error: payload,
      };

    case CHECK_SURVEYS_ACTION_TYPES.CLEAR:
      return initialState;
    default:
      return state;
  }
};

export const checkSurveysEpic = createAmplifyAPICallEpic({
  actionType: CHECK_SURVEYS_ACTION_TYPES.BEGIN,
  api: SEARCH_SURVEYS_ENDPOINT,
  successCallback: response => [checkSurveysAction.SUCCESS(response.body)],
  errorCallback: () => [checkSurveysAction.FAILURE()],
});
